export default {
	reminder: 'تذكير',

	headers: {
		reminderName: 'نوع التذكير',
		reminderDate: 'تاريخ التذكير',
	},

	inputs: {
		reminderName: 'نوع التذكير',
		reminderDate: 'تاريخ التذكير',

		reminderType: {
			salaryIncrease: 'زيادة رواتب',
			admission: 'تثبيت موظف',
			all: 'عامة',
		},
	},

	'delete-message-reminder': 'هل أنت متأكد من أنك تريد حذف هذا التذكير ؟'
};
